import { Injectable } from '@angular/core';
import * as _ from 'lodash';

import { AppService } from 'app/app.service';
import { QueueStatusEnum } from 'app/enums';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InterviewService } from 'app/interview.service';
import { TranzpayDialogComponent } from '@Components/tranzpay-embedded/tranzpay-dialog.component';
import { NotificationService, NotificationSeverity } from '@Services';

@Injectable()
export class TranzpayIntegrationResponseHandler{
    dialogRef: MatDialogRef<TranzpayDialogComponent>;

    constructor(
        public appService: AppService,
        public interviewService: InterviewService,
        public notificationService: NotificationService,
        public dialog: MatDialog
    ) {}

    handleResponse(clientId: string, accountId: string,integrationResponse, integrationData){
        if (this.dialogRef && this.dialogRef != null) {
            this.dialogRef.close();
            return;
        }

        if (integrationResponse.status === QueueStatusEnum.Completed) {
            const link = _.get(integrationData, 'details.clientProperties.linkUrl');
            const error = _.get(integrationData, 'details.clientProperties.error');

            if (error && error !== null && error !== '') {
                this.notificationService.showNotification({severity: NotificationSeverity.Error, message: error, log: true });
                return;
            }

            this.showTranzpayEmbeddedDialog(clientId, accountId, integrationData.caseDetailId, integrationData.caseIntegrationQueueId, link);
        }
    }

    showTranzpayEmbeddedDialog(clientId: string, accountId: string, caseId: string, caseIntegrationQueueId: string, link) {
        this.dialogRef = this.dialog.open(TranzpayDialogComponent, {
            width: '600px',
            height: '600px',
            data: {
                clientId: clientId,
                caseId: caseId,
                caseIntegrationQueueId: caseIntegrationQueueId,
                link,
                accountId: accountId
            }
        });

        this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef = null;
        });
    }
}
